export function formatDateInputMask(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 2) {
    return digits.length === 2 ? `${digits}/` : digits;
  }

  if (digits.length <= 4) {
    const formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    return digits.length === 4 ? `${formatted}/` : formatted;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function resolveDateInputCursor(formatted: string, digitsBeforeCursor: number): number {
  if (digitsBeforeCursor <= 0) {
    return 0;
  }

  const totalDigits = formatted.replace(/\D/g, '').length;

  if (digitsBeforeCursor >= totalDigits) {
    return formatted.length;
  }

  let digitsSeen = 0;

  for (let index = 0; index < formatted.length; index += 1) {
    if (!/\d/.test(formatted[index])) {
      continue;
    }

    digitsSeen += 1;

    if (digitsSeen === digitsBeforeCursor) {
      let cursor = index + 1;

      if (formatted[cursor] === '/') {
        cursor += 1;
      }

      return cursor;
    }
  }

  return formatted.length;
}

export function parseFormattedDate(value: string): Date | null {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim());

  if (!match) {
    return null;
  }

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);

  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  return date;
}
